var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerksAndEquipmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-perks{fill:#c5c9f6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hand-holding",
    "data-name": "Icon awesome-hand-holding",
    className: "cls-perks",
    d: "M20.16,12.42a1.18,1.18,0,0,0-1.5,0L15.42,15a2.29,2.29,0,0,1-1.4.49H9.87A.56.56,0,0,1,9.31,15a.57.57,0,0,1,.56-.57h2.74a1.15,1.15,0,0,0,1.17-.93,1.11,1.11,0,0,0-.92-1.29.58.58,0,0,0-.19,0H7.06a4.19,4.19,0,0,0-2.6.92L2.83,14.38H.89A.57.57,0,0,0,.33,15v3.36a.56.56,0,0,0,.56.56H13.4a2.21,2.21,0,0,0,1.4-.49l5.3-4.24a1.13,1.13,0,0,0,.19-1.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-box-open",
    "data-name": "Icon awesome-box-open",
    className: "cls-perks",
    d: "M12.62,5a1.07,1.07,0,0,1-.9-.51l-1.4-2.32L8.92,4.51A1,1,0,0,1,8,5a1,1,0,0,1-.29,0l-3-.85V8a.71.71,0,0,0,.53.68L10,9.86a1.56,1.56,0,0,0,.68,0l4.71-1.18A.71.71,0,0,0,15.9,8V4.13l-3,.85A.92.92,0,0,1,12.62,5Zm4.63-2.44L16.13.34a.34.34,0,0,0-.36-.19L10.32.84l2,3.31a.36.36,0,0,0,.4.16L17,3.08a.36.36,0,0,0,.24-.45l0,0ZM4.52.34,3.4,2.58a.35.35,0,0,0,.15.47l.07,0,4.3,1.23a.36.36,0,0,0,.4-.16l2-3.31L4.88.15A.35.35,0,0,0,4.52.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerksAndEquipmentIcon);
export default __webpack_public_path__ + "static/media/perks-and-equipment-icon.871f42688ebbed0c7e12cdbfe0394feb.svg";
export { ForwardRef as ReactComponent };